import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { LockKeyIcon } from "@phosphor-icons/react";

export default function Login() {
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  async function submit(e) {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(password);
      const dest = location.state?.from?.pathname || "/admin";
      navigate(dest, { replace: true });
    } catch (e) {
      const detail = e?.response?.data?.detail;
      setErr(detail || "Login failed");
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F1116] p-6 relative overflow-hidden">
      <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-gradient-to-br from-fuchsia-500/20 to-cyan-500/10 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-40 -left-40 w-96 h-96 rounded-full bg-gradient-to-br from-[#D6FF38]/10 to-transparent blur-3xl pointer-events-none" />

      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="relative w-full max-w-sm border border-[#2A2D3A] bg-[#15171E] rounded-lg p-8 space-y-5"
      >
        <div>
          <div className="flex items-center gap-2 text-[#D6FF38]">
            <LockKeyIcon size={16} />
            <div className="mono text-[10px] uppercase tracking-[0.3em]">Owner access</div>
          </div>
          <h1 className="text-2xl font-medium mt-2">AI Bot Lab</h1>
          <p className="mono text-[10px] text-[#64748B] mt-2 leading-relaxed">
            Private area. Storefront visitors don&apos;t need to sign in — this gate only protects the pipeline dashboard, admin tools and analytics.
          </p>
        </div>

        <div>
          <label htmlFor="pw" className="mono text-[9px] uppercase tracking-widest text-[#94A3B8]">
            Password
          </label>
          <input
            id="pw"
            data-testid="admin-login-password"
            type="password"
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-2 w-full bg-[#0F1116] border border-[#2A2D3A] rounded-md px-3 py-2 text-[#F1F5F9] focus:outline-none focus:border-[#D6FF38] transition-colors mono text-sm"
            required
          />
        </div>

        <div className="mono text-[10px] text-[#64748B] flex items-center gap-2">
          <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#2ECA7F]" />
          Session remembered for 30 days on this browser
        </div>

        {err && (
          <div data-testid="admin-login-error" role="alert" className="mono text-xs text-[#FF4D4D]">
            {err}
          </div>
        )}

        <button
          type="submit"
          data-testid="admin-login-submit"
          disabled={busy}
          className="w-full mono text-[10px] uppercase tracking-widest px-4 py-3 rounded-full bg-[#D6FF38] text-[#0F1116] hover:brightness-110 transition-all disabled:opacity-50"
        >
          {busy ? "signing in…" : "unlock lab"}
        </button>
      </form>
    </div>
  );
}
